import React from "react";
import Icon from "./Icon";

const DuplicateSvg = ({ className }) => (
  <Icon name="duplicate" className={className} strokeWidth={1.5} />
);

export default DuplicateSvg;
